var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.1,
    height: 64,
    viewBox: "0 0 58.1 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.5,23.65,31.05,3,57.6,23.65V56.1A5.9,5.9,0,0,1,51.7,62H10.4a5.9,5.9,0,0,1-5.9-5.9Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,47.5V18H31.2V47.5",
    transform: "translate(8.7 14.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherHome);
export default __webpack_public_path__ + "static/media/feather-home.3a0b02258b4a0f6bba28f819f3d6ec4a.svg";
export { ForwardRef as ReactComponent };